<template>
  <div v-loading="loading" class="newBox">
    <div v-show="!loading&&!showuser" class="loginboxs">
      <div style="text-align: center;overflow: hidden;position: absolute;top: 40px;left: 130px;cursor: pointer">
        <img :src="logo" alt="" @click="gohome">
      </div>
      <div style="text-align: center;font-size: 15px;padding-top: 150px;overflow: hidden;">
        绑定账号
      </div>
      <p style="color: #69513c;text-align: center;margin-top: 20px">
        <span style="display: inline-block;width: 300px;margin-bottom: 30px;">您已通过  微信账号   登录成功，请绑定手机号，以便登录更方便！</span>
      </p>
      <el-form ref="ruleForm" :model="ruleForm" status-icon :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item prop="phoneNumber" :error="errors.phone">
          <el-input v-model="ruleForm.phoneNumber" auto-complete="off" placeholder="请输入手机号 ">
            <i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="user" /></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="checkCode" :error="errors.code">
          <el-input v-model="ruleForm.checkCode" type="checkCode" auto-complete="off" placeholder="请确验证码 " class="checkbox">
            <i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="pwd" /></i>
          </el-input>
          <div v-show="isVcodeBtn" class="getVcodeBtn" @click="getVcode">
            获取验证码
          </div>
          <div v-show="!isVcodeBtn" class="getVcodeBtn num">
            重新发送 <span>({{ count }})</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="denglubtn" @click="submitForm('ruleForm')">
            绑定
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="!loading&&showuser" class="loginboxs">
      <div style="text-align: center;overflow: hidden;position: absolute;top: 40px;left: 130px;cursor: pointer">
        <img :src="logo" alt="" @click="gohome">
      </div>
      <div style="text-align: center;font-size: 15px;padding-top: 150px;overflow: hidden;">
        注册成功
      </div>
      <p style="color: #69513c;text-align: center;margin-top: 20px">
        <span style="display: inline-block;width: 300px;margin-bottom: 30px;">系统已经为您注册账号，请牢记，误外泄</span>
      </p>
      <div class="msgShow">
        <span class="msgShow_span1">登录账号 :</span><span class="msgShow_span2">{{ userAccount }}</span>
      </div>
      <div class="msgShow">
        <span class="msgShow_span1">登录密码 :</span><span class="msgShow_span2">{{ password }}</span>
      </div>
      <div class="gohome">
        <a href="/home">进入彭祖世家网</a>
      </div>
    </div>
  </div>
</template>
<script>
import { wxLoginCallback, userIsBinding, userWxUserRegister, addWeiXinUserUrl, getPhoneIs } from '@/api/login.js'
import { checkRegister, getVcode, cheakLogin } from '@/api/api.js'
// import topHead from '@/views/components/header.vue'
export default {
  // components: { topHead },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '',
      mateDesc: metaStr
    }
  },
  data() {
    var checkpass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var checkvcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'))
      }
      setTimeout(() => {
        if (!(/^1[34578]\d{9}$/.test(value))) {
          callback(new Error('格式错误，请输入正确的手机号'))
        } else {
          callback()
        }
      }, 200)
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value + '' !== this.ruleForm_new.password + '') {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      password: '',
      userAccount: '',
      showuser: false,
      newuser: false,
      errors: {
        code: '',
        phone: ''
      },
      dataKey: '',
      openid: '',
      logo: require('@/static/sarch_logo.png'),
      loading: true,
      loginIMG: require('@/static/loginIMG_new.png'),
      show: false,
      isVcodeBtn: true,
      count: 60,
      ruleForm: {
        phoneNumber: '',
        checkCode: ''
      },
      ruleForm_new: {
        checkPass: '',
        password: ''
      },
      rules: {
        phoneNumber: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        password: [
          { validator: checkpass, trigger: 'blur' }
        ],
        checkCode: [
          { validator: checkvcode, trigger: 'change' }
        ]
      },
      rules_new: {
        phoneNumber: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        password: [
          { validator: checkpass, trigger: 'blur' }
        ],
        checkCode: [
          { validator: checkvcode, trigger: 'change' }
        ]
      }
    }
  },
  created() {
    // this.$emit('footshow', 8)
  },
  mounted() {
    if (this.$route.query.code) {
      var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
      var newquery = this.$route.query
      if (is_mobi) {
        newquery.loginType = 'app'
      }
      wxLoginCallback(newquery).then(res => {
        if (res.data.isRegister == 1) {
          this.setloca('userid', res.data.fwUserId, 7200)
          this.setloca('readerUsrId', res.data.readerUsrId, 7200)
          // //登录成功跳转
          console.log(window.history.length)
          if (this.getLoca('isback')) {
            // console.log(this.getLoca('isback'))
            window.location.href = this.getLoca('isback')
          } else {
            if (is_mobi) {
              this.$router.push('/home')
            } else {
              this.$router.push('/user?index=0')
            }
          }
        } else if (res.data.isRegister == 2) {
          this.loading = false
          this.dataKey = res.data.jmKey
          // this.openid = res.data.openid
        } else if (res.data.isRegister == 3) {
          this.setloca('userid', res.data.fwUserId, 7200)
          this.loading = false
          this.showuser = true
          this.password = res.data.password
          this.userAccount = res.data.userAccount
        } else if (res.data.isRegister == 4) {
          this.$message({
            type: 'error',
            message: '服务器异常，请稍后再试'
          })
          this.$router.replace('/login')
        }
      })
    }
  },
  methods: {
    gohome() {
      this.$router.push({ path: '/home' })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs.ruleForm.clearValidate()
          var obj = {}
          obj.phone = this.ruleForm.phoneNumber
          obj.code = this.ruleForm.checkCode
          obj.dataKey = this.dataKey
          getPhoneIs({ phone: this.ruleForm.phoneNumber }).then(res => {
            if (res.data) {
              userIsBinding(obj).then(res => {
                if (res.data.isState == 0) {
                  // /成功
                  this.setloca('userid', res.data.fwUserId, 7200)
                  this.setloca('readerUsrId', res.data.readerUsrId, 7200)
                  this.showuser = true
                  this.password = res.data.password
                  this.userAccount = res.data.userAccount
                  // this.$router.push({ path: '/home' })
                }
                if (res.data.isState == 1 || res.data.isState == 3) {
                  this.errors = { code: '服务器异常' }
                }
                if (res.data.isState === 2) {
                  this.errors = { code: '验证码错误' }
                }
              })
            } else {
              this.errors = { code: '该手机号已经绑定' }
            }
          })
        }
      })
    },
    getVcode() {
      this.ruleForm.checkCode = ''
      if (!(/^1[34578]\d{9}$/.test(this.ruleForm.phoneNumber))) {
        this.$message({
          message: '请正确输入手机号',
          type: 'error',
          duration: 2000
        })
      } else {
        var obj = {}
        obj.phone = this.ruleForm.phoneNumber
        obj.codeType = '1'
        this.isVcodeBtn = false
        var timers = setInterval(() => {
          this.count--
          if (this.count <= 0) {
            this.isVcodeBtn = true
            clearInterval(timers)
          }
        }, 1000)
        getVcode(obj).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '短信验证已发送',
              type: 'success',
              duration: 2000
            })
          }
        })
      }
    }
  }

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .gohome{
    margin-top: 20px;
    text-align: center;
    a{
      display: inline-block;
      width: 180px;
      height: 40px;
      line-height: 40px;
      background-color: #E3003A;
      text-align: center;
      color: #ffffff;
      font-size: 18px;
    }
  }
  .msgShow{
    margin-top: 30px;
    text-align: center;
    overflow: hidden;
  }
  .msgShow_span1{
    font-size: 18px;
    color: #333;
  }
  .msgShow_span2{
    font-size: 16px;
    color: #E3003A;
  }
    .newBox{
        width: 100%;
        position: absolute;
        background-color: #B2B2B2;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 9;
        .loginboxs{
            height: 600px;
            width: 340px;
            background-color: #fff;
            text-align: center;
            padding: 0 80px;
           margin: 50px auto;
            position: relative;
            .denglubtn{
                width: 100%;
                background-color: #7E6B5A;
                border-color: #7E6B5A;
                margin-top: 20px;
            }
            .checkbox{
                width: 230px;
            }
            .getVcodeBtn{
                width: 100px;
                display: inline-block;
                background-color: #7E6B5A;
                margin-left: 10px;
                border-radius: 5px;
                text-align: center;
                color: #ffffff;
                font-size: 12px;
                cursor: pointer;
            }
            .num{
                background-color: #fff;
                color: #a19d9e;
                cursor: not-allowed;
                span{
                    font-size: 12px;
                    color: #a19d9e;
                }
            }
        }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
        .bgI{
            .contentBox{
                width: 80%;
                margin: 80px auto;
                .denglubtn{
                    width: calc( 80vw - 40px )
                }
                .register{
                    margin-bottom: 20px;
                }
            }
            .checkbox{
                width: calc( 80vw - 150px);
            }
        }
    }
</style>
